exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_steps__3LgLz {\n  flex: 1 0 auto;\n  margin: 0 !important;\n  padding: .5rem 2px !important;\n  text-align: center;\n  font-weight: bold !important;\n  /* background-image: linear-gradient(to right, #F7F7F7, var(--color-white)); */\n  box-shadow: var(--f7-button-raised-box-shadow);\n  background-color: var(--color-white);\n  z-index: 221;\n}\n\n.styles_stepActive__13T5j {\n  color: var(--cart-order-step-active-color);\n  font-weight: bold;\n}\n\n.styles_stepDisable__2hXdY {\n  color: var(--cart-order-step-disable-color);\n  font-weight: normal;\n}", ""]);

// Exports
exports.locals = {
	"steps": "styles_steps__3LgLz",
	"stepActive": "styles_stepActive__13T5j",
	"stepDisable": "styles_stepDisable__2hXdY"
};